import { useEffect, useState } from 'react';
import SideBar from './Component/Layout/SideBar';
import AppBody from './Component/Layout/AppBody';
import Login from './Component/Auth/Login';
import { AuthVM } from './Structure/ViewModels/Auth/AuthVM';
import { Globals } from './Structure/Globals/GlobalObs';
import LoginDevice from './Component/Auth/LoginDevice';



function App() {

  const [authvm , setAuthVm] = useState<{viewModel:AuthVM}>({viewModel:Globals.auth})
  const control = authvm.viewModel
  useEffect(()=>control.subscribeUpdate(setAuthVm),[])

  useEffect(()=>control.initiate(),[control.DeviceAuth])

  return (
    <div className='h-100 w-100'>
    { 
      control.Show(
        control.DeviceAuth?(
        control.Auth?(
          <div id='App'  className="App sideBar-hide txt-color-I" style={{ userSelect:Globals.auth.User?.permissions.some(a=>a.id=='36')?'auto':'none' }}>
            <SideBar />
            <AppBody/>
          </div>
        ):(<Login/>)):(<LoginDevice/>))
      }
    </div>
  );
  
}

export default App;
